export default {
  title: 'Alennuskoodin tiedot',
  back: 'Takaisin alennuskoodeihin',
  tabs: {
    customers: 'Asiakkaat',
    orders: 'Tilaukset',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Keskim. tilausarvo',
    customer_adoption: 'Yksittäiset asiakkaat',
  },
  toasts: {
    failed_to_load_stats: 'Tilastojen lataaminen epäonnistui',
  },
};
